import { hideScrollBar, IconFont, Input, pointer, singleTextEllipsis, tinyButtons } from '@byecode/ui'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
    background-color: var(--color-gray-50);
`

export const FinishButton = styled.div`
    font-weight: 500;
    color: var(--color-app-main);
    margin-left: auto;
    ${pointer}
`

export const Cursor = styled.div``

export const SearchInput = styled(Input)`
    height: 40px;
    &:focus-within {
        border-color: var(--color-app-main);
    }
`
export const Path = styled.div`
    /* margin: 12px 0; */
    display: flex;
    align-items: center;
    gap: 4px;
`

export const TagListContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    overflow-x: auto;
    ${hideScrollBar()}
`

export const Tag = styled.div`
    padding: 0 6px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    line-height: 24px;
    font-size: var(--font-size-normal);
    color: var(--color-black);
    border: 1px solid var(---color-gray-200);
    border-radius: 4px;
    background-color: var(--color-white);
`
